// src/pages/Gemini/userAssistantService.jsx
import axios from "axios";

const API_URL =
  "http://127.0.0.1:5001/confi-ai-20e6e/us-central1/aiAdsAssistant";

export const fetchUserAssistantInsight = async (question) => {
  try {
    const res = await axios.post(API_URL, {
      question,
      customer_id: "1176825945",
      model: "user_assistant",
    });

    if (!res.data?.success) {
      return {
        type: "text",
        content: "Unable to fetch user assistant response.",
      };
    }

    // If structured data exists → table
    if (res.data.data_summary) {
  return {
    type: "data_viz",
    answer: res.data.answer,
    data: res.data.data_summary,
  };
}

    // Otherwise → text
    return {
      type: "text",
      content: res.data.answer,
    };
  } catch (error) {
    console.error("User Assistant API Error:", error);
    return {
      type: "text",
      content: "User assistant service is unavailable.",
    };
  }
};
